import React from 'react';
import {Grid, Input} from 'semantic-ui-react';
import _ from 'lodash'
import {socket} from "../../lib/socketio";
import { VT310DELNOM_TAGS } from '../../constants/tags'

const PCSGroupColumn = ({index, column, data, ovrdata1, ovrdata2, internal}) => {
    const [tagdata, settagdata] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [dataCopy, setDataCopy] = React.useState();
    const [isCopied, setIsCopied] = React.useState(false);

    React.useEffect(() => {
        if (Object.keys(data).length !== 0 && !isCopied) {
            setDataCopy({...data});
            setIsCopied(true)
        }
    }, [data]);

    const handleSubmit = (event, value, id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
        }
        settagdata('');
    }

    const convertValue =(value, tag, tag_display_subgroup) => {
        if(value === 1){
            if(tag === 'PCS_BROWNOUT') return 'BROWNOUT';
            else if (tag === 'PCS_GRIDOK') return 'OK';
            else if(tag === 'PCS_TDGRIDNOTOK') return 'NOT OK';
            else if(tag === 'PCS_POWERFOLDBACK') return 'FOLDBACK';
            else if(tag === 'MAIN_OPERIN_EXTERNALPOWER' || tag === 'PSM1_OPERIN_EXTERNALPOWER' || tag === 'PSM2_OPERIN_EXTERNALPOWER' || 
                        tag === 'PSM3_OPERIN_EXTERNALPOWER' ||tag === 'PSM4_OPERIN_EXTERNALPOWER' ||tag === 'PSM5_OPERIN_EXTERNALPOWER') return 'EXTERNAL';
            else if(tag === 'PCS_MCBGRID' || tag === 'PCS_MCBINV' || tag === 'PCS_MCBLOAD') return 'CLOSE';
            else return 'ON'
        }
        else{
            if(tag === 'PCS_BROWNOUT') return 'NORMAL';
            else if (tag === 'PCS_GRIDOK') return 'NOT OK';
            else if(tag === 'PCS_TDGRIDNOTOK') return 'OK';
            else if(tag === 'PCS_POWERFOLDBACK') return 'NORMAL';
            else if(tag === 'MAIN_OPERIN_EXTERNALPOWER' || tag === 'PSM1_OPERIN_EXTERNALPOWER' || tag === 'PSM2_OPERIN_EXTERNALPOWER' || 
            tag === 'PSM3_OPERIN_EXTERNALPOWER' ||tag === 'PSM4_OPERIN_EXTERNALPOWER' ||tag === 'PSM5_OPERIN_EXTERNALPOWER') return 'LOCAL';
            else if(tag === 'PCS_MCBGRID' || tag === 'PCS_MCBINV' || tag === 'PCS_MCBLOAD') return 'OPEN';
            else return 'OFF'
        }
    }

    // *! SOFC HMI 태그 변경 필요함 
    const getVT310DelNom = (id, data) => {
        if(id === -1){
            return Math.round((data[739100] - data[709400]) * 100) / 100;
            // CP_VT310DELD, CONFIG_VT310NOMD
        }
        else if( id === -2) {
            return Math.round((data[739000] - data[709300]) * 100) / 100;
            // CP_VT310DELC, CONFIG_vT310NOMC
        }
        else if (id === -3) {
            return Math.round((data[738900] - data[709200]) * 100) / 100;
            // CP_VT310DELB, CONFIG_VT310NOMb
        }
        else if (id === -4 ) {
            return Math.round((data[738800] - data[709100]) * 100) / 100;
            // CP_VT310DELA, CONFIG_VT310NOMA
        }
        else {
            return 0;
        }
    };


    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
                <Grid columns='equal' style={styles.grid}>
                    <p style={{
                        color: 'white',
                        fontWeight: 'bold',
                        marginTop: '20px',
                        marginBottom: '0px'
                    }}>{typeof column[i][0] !== 'undefined' ? column[i][0].tag_display_subgroup : ''}</p>
                    {column[i].map(r =>
                        r.tag_display_subgroup === "CALCULATIONS" || r.name.slice(5,12) === "PCS_FSW"  ?
                            ''
                            :
                            r.name.slice(5,9) === 'DOUT' || r.name.slice(5,8) === 'DIN' || r.name.slice(5,9) === 'PCS_' ||
                            r.name.slice(5,9) === 'OPER' || r.name.slice(-6) === 'BREAKER' || (r.tag_display_subgroup === 'PCS1 OPERSTATUS' && r.datatype === 'Boolean') || (r.tag_display_subgroup === 'PCS1 EVNTSTATUS' && r.datatype === 'Boolean')
                            || (r.tag_display_subgroup === 'PCS2 OPERSTATUS' && r.datatype === 'Boolean') || (r.tag_display_subgroup === 'PCS2 EVNTSTATUS' && r.datatype === 'Boolean') || (r.tag_display_subgroup === 'PCS3 OPERSTATUS' && r.datatype === 'Boolean') || (r.tag_display_subgroup === 'PCS3 EVNTSTATUS' && r.datatype === 'Boolean')
                            || (r.tag_display_subgroup === 'PCS4 OPERSTATUS' && r.datatype === 'Boolean') || (r.tag_display_subgroup === 'PCS4 EVNTSTATUS' && r.datatype === 'Boolean') || (r.tag_display_subgroup === 'PCS5 OPERSTATUS' && r.datatype === 'Boolean') || (r.tag_display_subgroup === 'PCS5 EVNTSTATUS' && r.datatype === 'Boolean')?
                                <Grid.Row key={r.id} style={{padding: '2px 0'}}>
                                    <Grid.Column width='9' style={styles.name}>{r.tag_display_name}</Grid.Column>
                                    {r.name === 'PCS_GRIDOK' ?
                                        <Grid.Column
                                            style={{color: data[r.id] === 0 ? 'red' : 'white'}}>{convertValue(data[r.id], r.name)}</Grid.Column>
                                        :
                                        <Grid.Column
                                            style={{color: data[r.id] === 1 ? 'red' : 'white'}}>{convertValue(data[r.id], r.name)}</Grid.Column>
                                    }
                                </Grid.Row>
                                :
                                r.tag_display_name === 'VT310DELA-NOM' || r.tag_display_name === 'VT310DELB-NOM' || r.tag_display_name === 'VT310DELC-NOM' || r.tag_display_name === 'VT310DELD-NOM' ?
                                    <Grid.Row style={{padding: '2px 0'}}>
                                        <Grid.Column width={9} style={styles.name}>{r.tag_display_name} </Grid.Column>
                                        <Grid.Column>{(typeof data !== 'undefined' && data !== null) ?  VT310DELNOM_TAGS.includes(r) ? getVT310DelNom(r.id, data) : ('') : ''}</Grid.Column>
                                        <Grid.Column>{r.unit}</Grid.Column>
                                    </Grid.Row>
                                    :
                        <Grid.Row style={{padding: '2px 0'}}>
                            <Grid.Column width={9} style={styles.name}>{r.tag_display_name}   </Grid.Column>
                            <Grid.Column>{(typeof data !== 'undefined' && data !== null &&  data[r.id] !== null && typeof data[r.id] !== 'undefined' && !isNaN(data[r.id])) ? ((r.datatype !== 'Boolean') ? data[r.id].toFixed(2) : data[r.id]) : ''}</Grid.Column> 
                            {/** CP_VDCTOT A ~ B */}
                            <Grid.Column>{r.unit}</Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
        ))
    ))

    return (
        <Grid.Column key={index} style={{maxWidth: '1000px', padding: '0'}}>
            {gridColumn}
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    name: {
        color: 'yellow',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    }
};

export default React.memo(PCSGroupColumn);

